import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function Outsourcing() {
  return (
    <>
      <SEO
        title="Outsourcing | Fastlane ApS"
        description="5 grunde til, hvorfor det er en god ide at outsource transport og spedition til os: Fokusér på hovedforretning, træk på over 55 årsværks viden til en lav pris."
        canonicalUrl="https://fastlane.dk/outsourcing"
      />

      <PageHeader
        title="Outsourcing"
        subtitle="5 grunde til, hvorfor det er en god idé at outsource transport og spedition til Fastlane."
        breadcrumbs={[
          { label: 'Om os', path: '/om-os' },
          { label: 'Outsourcing' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {/* 5 grunde */}
          <div className="bg-sky-50/70 p-6 sm:p-8 rounded-2xl border border-sky-100 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-[#0f2b48]">
              5 grunde til, hvorfor det er en god ide at outsource transport og spedition til os:
            </h2>
            <ul className="space-y-3 text-sm sm:text-base text-slate-800">
              {[
                'I kan fokusere på jeres hovedforretningsområde',
                'I kan trække på en stor akkumuleret viden til en lav pris',
                'I får en fleksibel ressource i spidsbelastningssituationer',
                'I får en bedre kvalitet, effektivitet og kreativitet',
                'I får en ekstern konsulent til sparring'
              ].map((reason, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-sky-700 text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5">
                    {idx + 1}
                  </span>
                  <span className="font-semibold text-slate-900">{reason}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Styrker */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-[#0f2b48]">Styrker:</h2>
            <div className="space-y-3 text-slate-700 leading-relaxed text-base">
              <p>
                Vi lytter til vore kunder, og baseret på vores viden omkring markedet tilbyder vi en løsning, der passer til kundens behov.
              </p>
              <p>
                Vi forbedre kvalitet og kundetilfredshed på rutine transport ved at skabe en struktureret basis for løbende forbedring.
              </p>
              <p>
                Vi udfører ad hoc transporter (flytninger, projekttransport, ekspres o. lign.) til tiden ved at afklare opgaven præcist fra start, vælge de rette leverandører og derefter følge op mens jobbet afvikles.
              </p>
              <p>
                Vi er stærke indenfor transport af farligt gods og vedligeholder viden og software til servicering af denne niche.
              </p>
              <p>
                Vi er godkendte hos fødevarestyrelsen til transport af fødevarer.
              </p>
            </div>
          </div>

          {/* Målsætninger */}
          <div className="bg-slate-50 p-6 sm:p-8 rounded-2xl border border-slate-200 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-[#0f2b48]">Vi har følgende målsætninger:</h2>
            <ul className="space-y-2 text-sm sm:text-base text-slate-700">
              {[
                'at tage tid til at lytte',
                'at svare hurtigt',
                'at kommunikere præcist',
                'at sikre et højt ensartet kvalitetsniveau',
                'at forblive fleksibel og uafhængige af store bureaukratiske systemer',
                'at omgås kunder, leverandører og kolleger på en professionel og engageret måde'
              ].map((goal, idx) => (
                <li key={idx} className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-sky-600 text-xs shrink-0" aria-hidden="true" />
                  <span>{goal}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Klar til at outsource jeres fragtopgaver?</span>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Tag en uforpligtende snak med os
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
